import { InstanceOfCareSummary } from "./inistance_of_care_summary";

export class Match
{
    instanceOfCare: InstanceOfCareSummary;
    matchScore: number;
}